/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "subject_follower";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface SubjectFollowMode {
}

export enum SubjectFollowMode_Enum {
  PURSUIT = 0,
  ABSOLUTE_AZIMUTH = 1,
  UNRECOGNIZED = -1,
}

export function subjectFollowMode_EnumFromJSON(object: any): SubjectFollowMode_Enum {
  switch (object) {
    case 0:
    case "PURSUIT":
      return SubjectFollowMode_Enum.PURSUIT;
    case 1:
    case "ABSOLUTE_AZIMUTH":
      return SubjectFollowMode_Enum.ABSOLUTE_AZIMUTH;
    case -1:
    case "UNRECOGNIZED":
    default:
      return SubjectFollowMode_Enum.UNRECOGNIZED;
  }
}

export function subjectFollowMode_EnumToJSON(object: SubjectFollowMode_Enum): string {
  switch (object) {
    case SubjectFollowMode_Enum.PURSUIT:
      return "PURSUIT";
    case SubjectFollowMode_Enum.ABSOLUTE_AZIMUTH:
      return "ABSOLUTE_AZIMUTH";
    case SubjectFollowMode_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseSubjectFollowMode(): SubjectFollowMode {
  return {};
}

export const SubjectFollowMode = {
  encode(_: SubjectFollowMode, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SubjectFollowMode {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSubjectFollowMode();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SubjectFollowMode {
    return {};
  },

  toJSON(_: SubjectFollowMode): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SubjectFollowMode>, I>>(base?: I): SubjectFollowMode {
    return SubjectFollowMode.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SubjectFollowMode>, I>>(_: I): SubjectFollowMode {
    const message = createBaseSubjectFollowMode();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
